import moment from 'moment';
import {
  CaptureScheduleModalAction,
  CaptureScheduleModalActionTypes,
  CaptureScheduleModalState,
  Duration,
  PAGES_IN_ORDER,
  Status,
  TotalCapturesDuration,
} from '../../types/capture-schedule-modal';

import createRxStore from '..';

export const initialState: CaptureScheduleModalState = {
  open: false,
  selectedSensors: [],
  page: PAGES_IN_ORDER[0],

  status: Status.IDLE,

  duration: {
    type: Duration.TOTAL_CAPTURES,
    value: '',
  } as TotalCapturesDuration,
  captureDurationInSeconds: '180',
  capturesPerSchedule: '5',
  schedules: [],

  workingScheduleCopy: {
    time: '',
    daysOfWeek: [],
    numberOfEventRetries: '',
  },

  finalRequestStatus: Status.IDLE,
  finalRequestError: null,
};

function reducer(
  state: CaptureScheduleModalState,
  action: CaptureScheduleModalAction,
): CaptureScheduleModalState {
  switch (action.type) {
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_RESET:
      return initialState;

    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_PAGE:
      return { ...state, page: action.page };

    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_TYPE:
      let duration = state.duration;
      if (action.durationType !== duration.type) {
        if (action.durationType === Duration.END_DATE) {
          duration = {
            type: Duration.END_DATE,
            value: moment.utc().startOf('day'),
          };
        } else {
          duration = {
            type: Duration.TOTAL_CAPTURES,
            value: '',
          };
        }
      }
      return { ...state, duration };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_VALUE:
      return {
        ...state,
        duration: {
          ...state.duration,
          value: action.value as any,
        },
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURE_DURATION:
      return { ...state, captureDurationInSeconds: action.captureDuration };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURES_PER_SCHEDULE:
      return { ...state, capturesPerSchedule: action.capturesPerSchedule };

    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_TIME:
      return {
        ...state,
        workingScheduleCopy: {
          ...state.workingScheduleCopy,
          time: action.time,
        },
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_DAYS_OF_WEEK:
      return {
        ...state,
        workingScheduleCopy: {
          ...state.workingScheduleCopy,
          daysOfWeek: action.daysOfWeek,
        },
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_NUMBER_EVENT_RETRIES:
      return {
        ...state,
        workingScheduleCopy: {
          ...state.workingScheduleCopy,
          numberOfEventRetries: action.numberOfEventRetries,
        },
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_QUICK_MF:
      return {
        ...state,
        schedules: [
          ...state.schedules,
          {
            daysOfWeek: action.daysOfWeek,
            time: action.time,
            numberOfEventRetries: action.numberOfEventRetries,
          },
        ],
        workingScheduleCopy: initialState.workingScheduleCopy,
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_ADD_CAPTURE_SCHEDULE:
      const numberOfEventRetries = parseInt(
        state.workingScheduleCopy.numberOfEventRetries,
        10,
      );
      return {
        ...state,
        schedules: [
          ...state.schedules,
          {
            ...state.workingScheduleCopy,
            numberOfEventRetries: isNaN(numberOfEventRetries)
              ? 0
              : numberOfEventRetries,
          },
        ],
        workingScheduleCopy: initialState.workingScheduleCopy,
      };
    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_REMOVE_CAPTURE_SCHEDULE:
      return {
        ...state,
        schedules: state.schedules.filter((_, index) => index !== action.index),
      };

    case CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS:
      return {
        ...state,
        finalRequestStatus: action.status,
        finalRequestError: action.error,
      };

    default:
      return state;
  }
}

const CaptureScheduleModalStore = createRxStore(
  'CaptureScheduleModalStore',
  initialState,
  reducer,
);
export default CaptureScheduleModalStore;
